export class AppointmentStatusModel{
    ReferralStatusId: number;
    ReferralStatus: string;
    IsActive:boolean;

}